export const CM_BACKGROUND = 'DimGray';
export const HELPED_KEY = 'CM HELPED';
export const ROW_COUNT = 7;
export const COL_COUNT = 6;
export const YOUTUBE_CM = 'https://youtu.be/0288Qt6sDXM';
